import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const IMG =
  "https://images.unsplash.com/photo-1685613858397-64f79a0f3603?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwZ2lmdHMlMjBmbG93ZXJzfGVufDB8fHx8MTc4MzgzNzM2Mnww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-testid="about-page">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
          <div>
            <p className="label-tiny mb-3">Our story</p>
            <h1 className="font-serif text-4xl leading-tight text-[#2a2928] sm:text-5xl lg:text-6xl">
              Small moments,{" "}
              <span className="italic text-[#d08c8c]">enormously felt.</span>
            </h1>
            <p className="mt-6 text-[#7a7571]">
              BalloonBites is a boutique gifting studio born from a simple idea:
              a gift should feel like a memory in the making. Every stuffed
              balloon hamper and every custom-wrapped chocolate is handcrafted
              with intention, from the first petal to the final ribbon.
            </p>
            <p className="mt-4 text-[#7a7571]">
              We&apos;re a small team obsessed with detail — the weight of the card
              stock, the exact blush of a satin bow, the smell of the confetti
              as it falls. If it doesn&apos;t feel like a keepsake, it doesn&apos;t
              leave our studio.
            </p>
            <Link
              to="/shop"
              data-testid="about-cta"
              className="mt-10 inline-flex rounded-full bg-[#d08c8c] px-8 py-3.5 text-sm font-medium text-white hover:bg-[#b87a7a]"
            >
              Explore the collection
            </Link>
          </div>
          <div className="overflow-hidden rounded-[2rem] border border-[#e8e2da]">
            <img src={IMG} alt="Studio" className="aspect-[4/5] w-full object-cover" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
